import { render, staticRenderFns } from "./tendero.vue?vue&type=template&id=0897c360&scoped=true&"
import script from "./tendero.vue?vue&type=script&lang=js&"
export * from "./tendero.vue?vue&type=script&lang=js&"
import style0 from "./tendero.vue?vue&type=style&index=0&id=0897c360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0897c360",
  null
  
)

export default component.exports